import {REST_METHODS} from '@/src/app/constants/api';
import {SEARCH_FILTERS} from '@/src/app/constants/search';
import {getAuthorizationToken} from '@/src/app/utils/authorizationToken';
import authorizedFetch from '@/src/app/utils/authorizedFetch';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const USERS_PER_PAGE = 10;

const fetchUsersForUnitedTab = ({searchQuery, locale}) => {
  const method = getAuthorizationToken() ? authorizedFetch : unauthorizedFetch;

  // @ts-ignore
  return method({
    method: REST_METHODS.GET,
    path: `/api/v1/users/search`,
    queryParams: [
      {
        name: SEARCH_FILTERS.LANGUAGE,
        value: locale,
      },
      {
        name: SEARCH_FILTERS.SEARCH,
        value: searchQuery,
      },
      {
        name: SEARCH_FILTERS.PER_PAGE,
        value: USERS_PER_PAGE,
      },
    ],
  });
};

export default fetchUsersForUnitedTab;
